import { Component, OnInit, ViewChild, Output, EventEmitter, Inject, AfterViewInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { CriteriosAvaliacaoRiscoService } from 'src/app/services/criterios-avaliacao-risco.service';
import { IUniversoAuditavelModel } from 'src/app/models/universo-auditavel.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FiltroUniversoAuditavel } from 'src/app/models/filtro-universo-auditavel';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import { ITipoUniversoModel } from 'src/app/models/tipo-universo.model';
import { MatCheckboxChange } from "@angular/material/checkbox";
import { ICriteriosAvaliacaoRiscos } from 'src/app/models/criterios-avaliacao-riscos.model';
import { FiltroCriterioAvaliacaoRiscos } from 'src/app/models/filtro-criterio-avaliacao-riscos.model';
import { FiltroRiscosChavesModel } from "../../../../models/filtro-riscos-chaves.model";
import {
  ModalRiscosChavesImportacaoComponent
} from "../../shared/modal-riscos-chaves-importacao/modal-riscos-chaves-importacao.component";
import { RiscosChavesServices } from "../../../../services/riscos-chaves.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { ToastrService } from "ngx-toastr";
import { defaultDataAcessor } from "../../../../core/helpers/mat-sort-data-accessor";

const sortingDataAccessor = (item, property) => {
  switch (property) {
    case 'versao': return item.versao.trim().toLowerCase();
    case 'data': return item.data.trim().toLowerCase();
    case 'situacao': return item.situacao.trim().toLowerCase();
    case 'ativo':
      return item.ativo;
    default:
      return item.versao;
  }
};

@Component({
  selector: 'app-modal-selecao-criterio-avaliacao',
  templateUrl: './modal-selecao-criterio-avaliacao.component.html',
  styleUrls: ['./modal-selecao-criterio-avaliacao.component.scss']
})
export class ModalSelecaoCriterioAvaliacaoComponent extends BaseFormComponent implements OnInit, AfterViewInit {

  public semDados = true;
  public totalItens: number;
  public selecionado: ITipoUniversoModel;
  public filtro =  {} as FiltroCriterioAvaliacaoRiscos;
  public displayedColumns: string[] = ['selecao', 'nome'];
  public dataSource = new MatTableDataSource<IUniversoAuditavelModel>([]);
  public filtroRiscosChaves =  {} as FiltroRiscosChavesModel;
  public criTerioAvaliacaoId: number;
  public pageEvent: any;

  @ViewChild('TableOnePaginator', { static: true }) tableOnePaginator: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() nomeSelecionado = new EventEmitter<string>();

  constructor(private dialogRef: MatDialogRef<ModalSelecaoCriterioAvaliacaoComponent>,
              private criterioAvaliacaoService: CriteriosAvaliacaoRiscoService,
              private risosChavesService: RiscosChavesServices,
              localeService: BsLocaleService,
              public matDialog: MatDialog,
              public toastr: ToastrService,
              router: Router,
              route: ActivatedRoute,
              @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.paginator.pageSize = 10;
    this.filtro.ativo = true;
    this.filtro.colunaOrder = 'nome';
    this.filtro.itensPorPagina =  this.paginator.pageSize;
    this.buscar();
  }

  ngOnInit(): void {
    // this.buscar();
  }

  public buscar() {
    this.criterioAvaliacaoService.obterAtivos(this.filtro).then((res)=>{
      this.totalItens = res.dados.totalItens;
      // @ts-ignore
      this.dataSource = new MatTableDataSource<ICriteriosAvaliacaoRiscos>(res.dados.resultado);
      this.paginator = this.tableOnePaginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = defaultDataAcessor;
      this.dataSource._updateChangeSubscription();
      this.semDados = this.dataSource.filteredData.length === 0;

    }).catch((err)=> {
      this.exibirMensagemErro(err.mensagem);
    });
  }

  public async concluir() {
    if(this.data.source === 'novo-risco-chaves-avaliacao-risco'){
      this.dialogRef.close(this.selecionado);
    }else{
      this.filtroRiscosChaves.unidadeGestoraId =  this.data.unidadeGestoraId;
      this.filtroRiscosChaves.tipoUniversoAuditavelId =  this.data.tipoUniversoId;
      this.filtroRiscosChaves.ativo = true;

      const retorno =   await  this.risosChavesService.obter(this.filtroRiscosChaves);

      if(retorno.dados.resultado.length > 0){
        this.dialogRef.close();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = 'modal-component-importar';
        dialogConfig.width = '650px';
        dialogConfig.hasBackdrop = true;
        dialogConfig.disableClose = true;
        dialogConfig.data = {
          source: 'importar-risco-chaves-novo',
          unidadeGestoraId: this.data.unidadeGestoraId,
          tipoUniversoId: this.data.tipoUniversoId,
          criterioAvaliacaoId: this.criTerioAvaliacaoId,

        };
        const modal= this.matDialog.open(ModalRiscosChavesImportacaoComponent, dialogConfig);
        modal.afterClosed().subscribe((data) => {

        });

      }else{
        this.router.navigate(['/importar-arquivo-riscos-chaves/novo'], { queryParams: { unidadeGestoraId: this.data.unidadeGestoraId, tipoUniversoId: this.data.tipoUniversoId, criterioAvaliacaoId: this.criTerioAvaliacaoId } });
        this.dialogRef.close(this.selecionado);
      }
    }


  }
  public cancelar() {
    this.dialogRef.close(null);
  }

  public filtrar(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.semDados = this.dataSource.filteredData.length === 0;
  }

  onCheckboxChange(event: MatCheckboxChange, element: any){
    if (event.checked){
      this.selecionado = !this.selecionado || this.selecionado.id !== element.id ? element : null;
       this.nomeSelecionado = element.nome;
       this.criTerioAvaliacaoId = element.id;

    }
  }
  public selecionar(item: ITipoUniversoModel) {
    this.selecionado = !this.selecionado || this.selecionado.id !== item.id ? item : null;
    this.criTerioAvaliacaoId = item.id;
  }

  pageChanged(e) {
    this.filtro.pagina = e.pageIndex + 1;
    e.pageIndex = this.filtro.pagina;
    this.filtro.itensPorPagina = e.pageSize;
    this.buscar();
  }

}
